import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appHasRole]',
  standalone: false
})
export class HasRoleDirective {
  private requiredRoles: string[] = [];
  private currentRole: string = '';
  private isHidden = true;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set appHasRole(roles: string[]) {
    this.requiredRoles = roles || [];
    this.updateView();
  }

  @Input() set appHasRoleRole(role: string) {
    this.currentRole = (role || '').toUpperCase();
    this.updateView();
  }

  private updateView() {
    const reqRoles = this.requiredRoles.map(r => (r || '').toUpperCase());
    const hasRole = reqRoles.includes(this.currentRole);
    if (hasRole && this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    } else if (!hasRole && !this.isHidden) {
      this.viewContainer.clear();
      this.isHidden = true;
    }
  }
}
